// extracted by mini-css-extract-plugin
export var columnList = "_ck-0";